'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayCurrencies = exports.getCurrencies = undefined;

var _utils = require('./utils');

/**
 * Get all active currencies that are currently enabled on the skin
 * @param {string} playerSessionID
 */
var getCurrencies = exports.getCurrencies = function getCurrencies() {
  return (0, _utils.get)('/currencies');
};

/**
 * Get all active display currencies that are currently enabled on the skin
 * @param {string} playerSessionID
 */
var getDisplayCurrencies = exports.getDisplayCurrencies = function getDisplayCurrencies() {
  return (0, _utils.get)('/currencies/display');
};

exports.default = {
  getCurrencies: getCurrencies,
  getDisplayCurrencies: getDisplayCurrencies
};